import React, { memo } from 'react';

interface SpinnerProps {
  size?: number;
  color?: string;
  className?: string;
}

const Spinner = memo(({ size = 24, color = '#000000', className = '' }: SpinnerProps) => {
  return (
    <div className={`inline-block ${className}`} role="status" aria-label="loading">
      <div
        className="animate-spin"
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          border: `2px solid ${color}`,
          borderTopColor: 'transparent',
          borderRightColor: 'transparent',
        }}
      />
    </div>
  );
});

Spinner.displayName = 'Spinner';

export default Spinner;
